import React from "react";
import { RouteComponentProps } from "react-router";
import { UserDetails } from "../UserDetails";

export const CustomerDetails: React.FC<RouteComponentProps<any>> = (props) => (
  <UserDetails {...props} viewType="customers" />
);
